import React, { ChangeEvent, useState } from "react";
import { ErrorMsg, FieldWrapper, Input, RequiredStar } from "../styles";

type FormGroupProps = {
  handleChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handleBlur: React.ChangeEventHandler;
  placeholder: string;
  type: string;
  name: string;
  values: string | number;
  id: string;
  errors?: string;
  touched?: boolean;
  required?: boolean;
  disableMargin?: boolean;
};

export const FormProfileGroup: React.FC<FormGroupProps> = ({
  handleChange,
  handleBlur,
  placeholder,
  type,
  name,
  values,
  errors,
  touched,
  id,
  required,
  disableMargin
}) => {
  const [hasValue, setHasValue] = useState(!!values);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    handleChange(e);
    setHasValue(!!e.target.value);
  };

  return (
    <FieldWrapper $disableMargin={disableMargin}>
      {
        required && !hasValue
          ? <RequiredStar>*</RequiredStar>
          : ''
      }
      <Input
        $error={!!(errors && touched)}
        $hasValue={hasValue}
        $required={required && !hasValue}
        id={id}
        type={id === "password" ? "text" : type}
        name={name}
        onChange={handleInputChange}
        onBlur={handleBlur}
        placeholder={`${placeholder}`}
        value={values}
      >
      </Input>
      {errors && touched && <ErrorMsg>{errors}</ErrorMsg>}
    </FieldWrapper>
  );
};
